import React, { useEffect, useState } from "react";
import { getOrdersData } from "../service/inventoryService";

const Sales = () => {
  const lsUserVO = process.env.REACT_APP_LS_USER_VO;
  const pimsUserVO = JSON.parse(localStorage.getItem(lsUserVO));

  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [salesData, setSalesData] = useState([]);
  const ordersPerPage = 50;

  const indexOfLastOrder = currentPage * ordersPerPage;
  const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;

  const fetchSalesData = async () => {
    try {
      const salesOrders = await getOrdersData(pimsUserVO.branchId, "SALE_ORDER");
      setSalesData(salesOrders);
    } catch (error) {
      console.error("Error fetching sales orders:", error);
    }
  };

  useEffect(() => {
    fetchSalesData();
  }, []);

  // Filter orders based on search query
  const filteredOrders = searchQuery
    ? salesData.filter(
        (order) =>
          order.customerVO.name
            .toLowerCase()
            .includes(searchQuery.toLowerCase()) ||
          order.orderDate.includes(searchQuery) ||
          order.id.toString().includes(searchQuery)
      )
    : salesData;

  const currentOrders = filteredOrders.slice(
    indexOfFirstOrder,
    indexOfLastOrder
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="container mx-auto p-4 sm:p-8">
      <h2 className="text-2xl sm:text-3xl font-bold mb-4 sm:mb-6">
        Sales Orders
      </h2>

      {/* Search input */}
      <div className="mb-4">
        <input
          type="text"
          className="w-full p-2 border rounded-md"
          placeholder="Search by patient or Order Date or Order Id"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      {/* Display a message if there are no orders */}
      {currentOrders.length === 0 ? (
        <div
          className="bg-green-200 rounded-md p-4 mb-8 flex items-center justify-center"
          style={{ height: "200px" }}
        >
          <h3 className="text-xl sm:text-2xl font-bold text-center">
            No sales orders found.
          </h3>
        </div>
      ) : (
        currentOrders.map((order) => (
          <div key={order.id} className="bg-green-200 rounded-md p-4 mb-8">
            <h3 className="text-xl sm:text-2xl font-bold mb-2 sm:mb-4">
              Order : {order.id}
            </h3>
            <div className="mb-4 sm:mb-6">
              <p className="text-lg font-bold mb-2">
                Order Date: {order.orderDate}
              </p>
              <p className="text-lg font-bold mb-2">
                Patient: {order.customerVO.name}
              </p>
            </div>

            {/* Order details table */}
            <div className="overflow-x-auto">
              <table className="min-w-full border-collapse border border-gray-300">
                <thead>
                  <tr className="bg-green-400">
                    <th className="px-4 py-2 border border-gray-300">
                      Medicine Name
                    </th>
                    <th className="px-4 py-2 border border-gray-300">
                      Quantity
                    </th>
                    <th className="px-4 py-2 border border-gray-300">MRP</th>
                    <th className="px-4 py-2 border border-gray-300">
                      Final Price
                    </th>
                    <th className="px-4 py-2 border border-gray-300">Total</th>
                  </tr>
                </thead>
                <tbody>
                  {order.orderItemVO.map((item, itemIndex) => (
                    <tr key={itemIndex}>
                      <td className="px-4 py-2 border border-gray-300">
                        {item.medicineVO.medName}
                      </td>
                      <td className="px-4 py-2 border border-gray-300">
                        {item.qty}
                      </td>
                      <td className="px-4 py-2 border border-gray-300">
                        {item.mrp}
                      </td>
                      <td className="px-4 py-2 border border-gray-300">
                        {item.finalPrice}
                      </td>
                      <td className="px-4 py-2 border border-gray-300">
                        {item.totPrice}
                      </td>
                    </tr>
                  ))}
                  {/* Totals row */}
                  <tr className="bg-green-400 font-bold">
                    <td className="px-4 py-2 border border-gray-300">
                      Total QTY
                    </td>
                    <td className="px-4 py-2 border border-gray-300">
                      {order.orderItemVO.reduce(
                        (total, item) => total + item.qty,
                        0
                      )}
                    </td>
                    <td className="px-4 py-2 border border-gray-300"></td>
                    <td className="px-4 py-2 border border-gray-300">
                      Total Price
                    </td>
                    <td className="px-4 py-2 border border-gray-300">
                      {order.orderItemVO
                        .reduce((total, item) => total + item.totPrice, 0)
                        .toFixed(2)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            {/* End of Order details table */}
          </div>
        ))
      )}

      {/* Pagination */}
      <div className="flex justify-center">
        <nav className="bg-white border border-gray-300 rounded-md">
          <ul className="flex">
            {Array.from(
              { length: Math.ceil(filteredOrders.length / ordersPerPage) },
              (_, i) => (
                <li key={i}>
                  <button
                    className={`px-4 py-2 mx-1 font-semibold focus:outline-none ${
                      currentPage === i + 1
                        ? "bg-gray-800 text-white"
                        : "bg-white text-gray-700 hover:bg-gray-200"
                    }`}
                    onClick={() => paginate(i + 1)}
                  >
                    {i + 1}
                  </button>
                </li>
              )
            )}
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default Sales;
